import { render, staticRenderFns } from "./CheckingInJournalForm.vue?vue&type=template&id=06b64a76&scoped=true&"
import script from "./CheckingInJournalForm.vue?vue&type=script&lang=js&"
export * from "./CheckingInJournalForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06b64a76",
  null
  
)

export default component.exports